export default function () {
	return {
		categories: [],
		category: 'all',
		search: ''
	}
}
